<template>
  <div
    class="main-menu"
    :class="{
      '-black-theme': blackTheme,
      '-desktop': $mqAliases.desktop,
    }"
    ref="nav"
    aria-label="menu"
  >
    <nav :class="{ ' grid': $mqAliases.desktop }">
      <ul
        v-if="menu"
        class="main-menu-accordion accordion"
        :class="{ 'g-5-8 d-flex': $mqAliases.desktop }"
        role="menubar"
        aria-label="menu"
      >
        <li
          :class="{
            'hide-on-desktop': item.HideOnDesktop,
            'hide-on-mobil': item.HideOnMobil,
          }"
          role="presentation"
          v-for="(item, index) in menu"
          :key="index"
        >
          <MenuItem
            ref="mainDrawer"
            @scrollToMeOpen="scrollTo(index, false)"
            @scrollToMeClose="scrollTo(0, true)"
            :model="item"
            :index="index"
            :disableHover="disableHover"
          />
        </li>
         <li class="finstore-drawer" v-if="!$mqAliases.desktop">
          <transition name="fade-slow">
             <div v-if="open" class="menu-item accordion-drawer">
                <h3 ref="header -link">
                  <button @click="gotoStoreFinderPage()" role="menuitem" class="d-flex justify-content-between">
                      <span class="font-responsive-body">{{ insertString("Global", "FindStore") }}</span>
                      <Chevron :direction="'right'" :thickness="'thin'" :color="'#fcfcfc'" />
                  </button>
                </h3>
              </div>
          </transition>
        </li>
         <li
          v-if="bagItem && !$mqAliases.desktop"
          class="hide-on-desktop"
          role="presentation"
        >
            <transition name="fade-slow">
              <div v-if="open">
              <BagItem
                v-show="bagItem.visible"
                :animate="true"
                :isMenuItem="true"
                :keepColor="false"
                :class="{'-enabled': bagItem.visible}"
                :model="bagItem"
              />
              </div>
            </transition>
        </li>
        <li class="usb-drawer p-b-36" v-if="!$mqAliases.desktop">
          <transition name="fade-slow">
            <USPPoster v-if="open" :small="true" />
          </transition>
        </li>
      </ul>
      <div
        v-else
        class="
          main-menu-loader
          d-flex
          justify-content-center
          align-items-center
          -keep-color
        "
      >
        <SvgComponent
          v-show="!$mqAliases.desktop"
          :icon="{ name: 'Loading', color: Globals.colors.gray, size: 24 }"
        />
      </div>
    </nav>
  </div>
</template>
<script>
import { ANIMATION_CONSTANTS } from '@/Scripts/constants';
import ClickOutside from 'vue-click-outside';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import { mapState } from 'vuex';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import BagItem from '@/Scripts/components/layout/bag/BagItem.vue';
import Chevron from '@/Scripts/components/shared/svg/Chevron/Chevron.vue';

const SvgComponent = () => import('@/Scripts/components/shared/svg/Svg.vue');
const MenuItem = () => import('@/Scripts/components/layout/menu/MenuItem.vue');
const USPPoster = () => import('@/Scripts/components/shared/USPPoster/USPPoster.vue');
gsap.registerPlugin(ScrollToPlugin);

export default {
  mixins: [siteInfo],
  directives: {
    ClickOutside
  },
  components: {
    MenuItem,
    SvgComponent,
    USPPoster,
    BagItem,
    Chevron

  },
  props: {
    addSearchField: Boolean,
    open: Boolean,
    disableHover: Boolean,
    site: String
  },
  watch: {
    customer (val) {
      if (val) {
        if (this.site === 'b2b' && val.HasReplenishment) {
          this.addCustomMenuItem({
            Name: 'Replenishment',
            TrackId: 'Replenishment',
            Link: this.getLink('B2BReplenishmentPage')
          }, 0, 0, 3);

          this.hideCustomMenuItem({
            TrackId: 'Reorder'
          }, 0, 0);
          this.hideCustomMenuItem({
            TrackId: 'Preorder'
          }, 0, 0);
        }

        if (this.site === 'b2b' && val.HasStaffUniformPermission) {
          this.addCustomMenuItem({
            Name: 'Staff Uniform',
            TrackId: 'Workwear',
            Link: this.getLink('B2BWorkwearPage')
          }, 0, 0, 3);
        }
      }
    }
  },

  data () {
    return {
      menu: {}
    };
  },
  computed: {
    ...mapState({
      customer: state => state.b2bCustomer ? state.b2bCustomer.customer : null,
      isLoggedIn: state => state.appContext.isLoggedIn
    }),
    blackTheme () {
      return !this.$mqAliases.desktop;
    },
    bagItem () {
      if (this.site === 'b2b') {
        return null;
      }
      return {
        name: this.isLoggedIn ? this.insertString('Global', 'Account', 'Account') : this.insertString('Global', 'Account', 'AccountLogin'),
        type: 'LoginForm',
        action: this.isLoggedIn ? 'link' : 'drawer',
        icon: 'User',
        link: 'MyAccount',
        visible: true
      };
    }
  },
  methods: {
    gotoStoreFinderPage () {
      window.location.href = this.getLink('storeFinderPage');
    },
    addCustomMenuItem (menuItemToAdd, mainIndex, categoryIndex, itemIndex) {
      this.menu[mainIndex].SecondLayers[categoryIndex].Items.splice(itemIndex, 0, menuItemToAdd);
    },
    hideCustomMenuItem (menuItemToHide, mainIndex, categoryIndex) {
      const removeIndex = this.menu[mainIndex].SecondLayers[categoryIndex].Items.findIndex(i => i.TrackId === menuItemToHide.TrackId);
      if (removeIndex !== -1) {
        this.menu[mainIndex].SecondLayers[categoryIndex].Items.splice(removeIndex, 1);
      }
    },
    getIndex (el) {
      let i = 0;
      while (el.previousElementSibling) {
        el = el.previousElementSibling;
        i++;
      }
      return i;
    },
    initAllDrawers () {
      if (this.menu && this.$refs.mainDrawer) {
        // this.$refs.mainDrawer.forEach(function (element, index) {
        //   element.animateIntro(index);
        // });
      }
    },
    closeAllOpenDrawers () {
      eventBus.$emit('closeAllOpenDrawers');
    },

    scrollTo: function (index, scrollToTop) {
      const drawerHeight = 60;
      if (this.addSearchField) {
        index += 1;
      }
      if (scrollToTop && typeof this.menu !== 'undefined') {
        const h = Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        );
        if (this.menu.length * drawerHeight < h) {
          index = 0;
        } else {
          return;
        }
      }
      const top = index * drawerHeight;
      gsap.to(this.$refs.nav, ANIMATION_CONSTANTS.NORMAL, {
        scrollTo: {
          y: top,
          autoKill: false
        },
        ease: 'expo.easeOut'
      });
    },
    manipulateB2BMenu (menu) {
      return menu;
    }
  },
  mounted () {
    if (window.menuData && window.menuData.Menu) {
      this.menu = window.menuData.Menu;
    };

    document.body.addEventListener('keyup', e => {
      if (e.key === 'Escape') {
        this.closeAllOpenDrawers();
      }
    });
  }
};
</script>
<style lang="scss" src="@/scss/components/accordion/components.accordion.scss"></style>
<style lang="scss">
@import "@/scss/defaults.scss";

.main-menu {
  border-top: 1px solid $black-light;
  .usb-drawer {
    background-color:$black;
    position: relative;
    min-height:250px;
  }
  .usp-poster {
    margin: 0 !important;
    border-top: 1px solid $black-light !important;
  }
  .main-menu-accordion {
    padding: 0;
    > li {
      transition: all 0.3s;
    }
  }
  &.-black-theme {
    color: $white;
    background-color: $black;
    a {
      color: $white;
    }
    .bagitem button {
      color: $white;
    }
  }
  &-loader {
    min-height: 60px;
    @include media-breakpoint-down(md) {
      position: absolute;
      top: 45%;
      width: 100%;
    }
  }

  &.-desktop {
    display: flex;
    align-items: center;
    pointer-events: none;
    width: 100%;
    border-width: 0;

    &.-closed {
      overflow: hidden !important;
    }

    position: absolute;
    top: 0;
    height: auto;
    overflow: visible;
    background-color: transparent;
    height: 60px;

    .main-menu-accordion {
      position: static;
      > li {
        @include headerTheme($white, $black);
        background-color: transparent;

        .menu-item-content-wrapper {
          @include headerTheme($white, $black);
        }

        .-black-theme & {
          color: $white;
          a {
            color: $white;
          }
          .menu-item-content-wrapper {
            @include headerTheme($black, $white);
          }
        }
        .-blackest-theme & {
          .menu-item-content-wrapper {
            @include headerTheme($blackest, $white);
          }
        }
        .-transparent-header & {
          background-color: transparent;
        }

        .-transparent-header.-transparent-header-theme-white & {
          color: $white;
          a {
            color: $white;
          }
        }
        .-transparent-header.-transparent-header-theme-black & {
          color: $black;
          a {
            color: $black;
          }
        }
        &:first-of-type {
          margin-left: -(map-get($grid-gutter-widths, lg) / 2);
        }
        > div {
          color: inherit;
          background-color: inherit;
          padding-right: map-get($grid-gutter-widths, lg) / 2;
          padding-left: map-get($grid-gutter-widths, lg) / 2;
          //display: none;

          // &:nth-child(-n + #{$main-menu-max-items-lg}) {
          //   // +1 = search field takes first position in list
          //   display: list-item;
          // }
        }
      }
    }
  }
  .fade-slow-leave-active,
  .fade-slow-enter-active {
    transition: opacity 1s;
    opacity: 1;
  }

  .fade-slow-enter,
  .fade-slow-leave-to {
    opacity: 0;
  }
}

.usp-bar + .main-header-wrapper + .main-menu.-desktop {
  top: 48px;
}
.b2b-userbar + .main-header-wrapper + .main-menu.-desktop {
  top: 60px;
}
</style>
